import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { ArrowDropDownRounded, DateRangeRounded } from "@mui/icons-material";

import { locale } from "./NuDateUtils";
import { StyledDateRangePicker } from "./styled/StyledDateRangePicker";

import "./css/daterangepicker.css";
import "./css/bs.css";

export function SelectDate({ dateChanged, date, minDate, maxDate, handleEvent }) {
    const label = date.format(locale.format);

    return (
        <Container>
            <DateIcon data-testid="date-icon" aria-hidden="true" />
            <label htmlFor="date-input">Date</label>
            <DateDiv>
                <StyledDateRangePicker
                    data-testid="date-range-picker"
                    initialSettings={{
                        startDate: date,
                        locale,
                        linkedCalendars: false,
                        showDropdowns: true,
                        singleDatePicker: true,
                        minDate: minDate,
                        maxDate: maxDate
                    }}
                    onApply={dateChanged}
                    onEvent={handleEvent}
                >
                    <Autocomplete
                        data-testid="date-input"
                        id="date-input"
                        type="text"
                        value={label}
                        readOnly
                    />
                </StyledDateRangePicker>
                <CaretDown fontSize="small" aria-hidden="true" />
            </DateDiv>
        </Container>
    );
}

const Container = styled.div`
    display: inline-flex;
    align-items: center;
`;

const CaretDown = styled(ArrowDropDownRounded)`
    && {
        position: absolute;
        right: 0;
        top: 0;
    }
`;

export const DateIcon = styled(DateRangeRounded)`
    && {
        font-size: 1rem;
        margin-right: 4px;
    }
`;

export const DateDiv = styled.div`
    position: relative;
    margin-left: 18px;
    margin-right: 10px;
`;

export const Autocomplete = styled.input`
    border: 1px solid #000;
    width: 95px;
    cursor: pointer;
    padding-left: 0.5rem;
`;

SelectDate.propTypes = {
    dateChanged: PropTypes.func,
    date: PropTypes.object,
    minDate: PropTypes.object,
    maxDate: PropTypes.object,
    handleEvent: PropTypes.func
};
